import { render, staticRenderFns } from "./UserTwoFactorSetup.vue?vue&type=template&id=5a3ef8de&"
import script from "./UserTwoFactorSetup.vue?vue&type=script&lang=js&"
export * from "./UserTwoFactorSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports